import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { SkeletonTable, SkeletonText } from 'ui/components/skeleton';
import { currencyFormat } from 'utilities/common';
import _ from 'underscore';

const initialState = {
  items: null,
};

export const Item = ({ data, type }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['StockOpname.Show']
  );

  const [{ items }, setState] =
    React.useState(initialState);

  React.useEffect(() => {
    if (!data) return

    let items = []
    _.each(data, function(i) {
      const item = {
        item: i?.item,
        type: 'Keluar',
        quantity: i?.initial_quantity - i?.actual_quantity,
        stock_available: i?.initial_quantity,
        stock_final: 0
      };

      item.stock_final =  i?.initial_quantity - item.quantity

      if (i?.stock_defect > 0) {
        item.type = 'Defect'
        item.quantity = i?.defect_quantity
        item.stock_final = i?.initial_quantity - i?.defect_quantity
      }

      if (i?.actual_quantity > i?.initial_quantity) {
        item.type = 'Masuk'
        item.quantity = i?.actual_quantity - i?.initial_quantity
        item.stock_final = i?.actual_quantity
      }

      items.push(item)
    })

    setState((prevState) => ({ ...prevState, items: items }));
  }, [data]);

  const render = () => {
    var table = null;

    if (type === 'adjustment') {
      table = (
        <table
          width="100%"
          className="table table-hover table-vcenter card-table datatable border"
        >
          <thead className="bg-light">
            <tr className="th">
              <td style={{ whiteSpace: 'initial', width: '100px' }}>Kode</td>
              <td style={{ whiteSpace: 'initial', width: '300px' }}>Item</td>
              <td style={{ whiteSpace: 'initial', width: '5px' }}>Tipe</td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '100px',
                  textAlign: 'end',
                }}
              >
                Stock
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '100px',
                  textAlign: 'end',
                }}
              >
                Quantity
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '100px',
                  textAlign: 'end',
                }}
              >
                Final Stock
              </td>
            </tr>
          </thead>
          <tbody>
            {items?.map((s, i) => (
              <tr key={i}>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  <div>{s?.item?.code}</div>
                </td>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  <div>{s?.item?.alias_name}</div>
                </td>
                <td
                  style={{ whiteSpace: 'initial', width: '200px' }}
                >
                  <div
                    className={cn('badge ms-auto', s?.type === 'Defect' ? 'bg-danger-lt': s?.type === 'Keluar' ? 'bg-warning-lt': 'bg-primary-lt')}
                  >
                    Stock {s?.type}
                  </div>
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '150px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.stock_available)}
                  &nbsp;
                  {s?.item?.default_fraction}
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '150px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.quantity)}
                  &nbsp;
                  {s?.item?.default_fraction}
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '150px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.stock_final)}
                  &nbsp;
                  {s?.item?.default_fraction}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    } else if (type === 'opname') {
      table = (
        <table
          width="100%"
          className="table table-hover table-vcenter card-table datatable border"
        >
          <thead className="bg-light">
            <tr className="th">
              <td style={{ whiteSpace: 'initial', width: '100px' }}>Kode</td>
              <td style={{ whiteSpace: 'initial', width: '250px' }}>Item</td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '100px',
                  textAlign: 'end',
                }}
              >
                Stock
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '100px',
                  textAlign: 'end',
                }}
              >
                Quantity Opname
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '100px',
                  textAlign: 'end',
                }}
              >
                Quantity Defect
              </td>
            </tr>
          </thead>
          <tbody>
            {data?.map((s, i) => (
              <tr key={i}>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  <div>{s?.item?.code}</div>
                </td>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  <div>{s?.item?.alias_name}</div>
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '150px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.initial_quantity)}{' '}
                  {s?.item?.default_fraction}
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '150px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.actual_quantity)}{' '}
                  {s?.item?.default_fraction}
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '150px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.defect_quantity)}{' '}
                  {s?.item?.default_fraction}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    return table;
  };

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3" id="items">
      <div className="fw-semibold py-2 border-bottom" style={{ fontSize: 13 }}>
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Rincian Item'
        )}
      </div>
      <div className="pt-2">
        {StateLoading ? (
          <SkeletonTable headerCount={3} bodyCount={4} />
        ) : (
          <div className="table-responsive">{render()}</div>
        )}
      </div>
    </section>
  );
};
